export default {
      id: "wapp-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#wapp",
      toString: function () {
        return this.url;
      }
    }